<template>
  <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="form">
          <div class="alert alert-danger" v-if="exist">
            Użytkownik o podanym adresie email już istnieje
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.fullName.$error }">
                <label>Imię i nazwisko*</label>
                <input class="form-control form-control-lg" type="text" v-model="fullName"/>
                <labelInfo v-if="!$v.fullName.required" type="error" message="To pole jest wymagane"/>
                <labelInfo v-if="!$v.fullName.minLength" type="error" message="Wprowadź minimum 4 znaki"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.email.$error }">
                <label>E-mail*</label>
                <input class="form-control form-control-lg" type="email" name="" v-model="email"/>
                <labelInfo v-if="!$v.email.email" type="error" message="Podaj prawidłowy adres e-mail"/>
                <labelInfo v-if="!$v.email.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.company.$error }">
                <label>Nazwa firmy*</label>
                <vueselect class="select--list" :options="companiees" :value="selectedCompany" label="name" v-model="selectedCompany" @input="setCompany">
                    <template slot="no-options">
                      <p>Brak rekordów</p>
                    </template>
                </vueselect>
                <labelInfo v-if="!$v.company.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.roles.$error }">
                <label>Uprawnienia*</label>
                <vueselect class="select--list" :options="roles" v-model="selectedRole" label="name" :value="selectedRole" @input="setRole">
                    <template slot="no-options">
                      <p>Brak rekordów</p>
                    </template>
                </vueselect>
                <labelInfo v-if="!$v.roles.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.category.$error }">
                <label>Kategoria*</label>
                <vueselect class="select--list" autocomplete="false" :options="categories" :value="selectedCategory" label="name" v-model="selectedCategory" @input="setCategory">
                    <template slot="no-options">
                      <p>Brak rekordów</p>
                    </template>
                </vueselect>
                <labelInfo v-if="!$v.category.required" type="error" message="To pole jest wymagane"/>
              </div>
            </div>
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.parentMarket.$error }" v-if="company === 2 || company == null">
                <label>Market macierzysty*</label>
                <vueselect :options="markets" label="sapNumber" class="select--list" :value="selectedParentMarket" v-model="selectedParentMarket" @input="setParent">
                  <template slot="selected-option" slot-scope="option">
                      {{option.sapNumber}} {{option.gallery_city}} {{option.number}} {{option.gallery}} {{option.category ? option.category.name : ''}}
                  </template>
                  <template slot="option" slot-scope="option">
                      {{option.sapNumber}} {{option.gallery_city}} {{option.number}} {{option.gallery}} {{option.category ? option.category.name : ''}}
                  </template>
                    <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.parentMarket.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" v-on-clickaway="closeList" v-if="company === 2 || company == null">
                <label>Markety podrzędne</label>
                <div class="form-control form-control-lg sub-markets-display" v-show="!showList" @click="showList = !showList">
                  <div class="sub-markets-display__body">
                    <ul>
                      <li v-for="market in subMarkets">{{market.sapNumber}} {{market.gallery_city}} {{market.number}} {{market.gallery}} {{market.category ? market.category.name : ''}},</li>
                    </ul>
                  </div>
                </div>
                <img class ="form-group__icon" src="@/assets/symbols/search.svg" v-if="!showList">
                <input class="form-control form-control-lg search" type="text" v-model="search" v-show="showList" placeholder="Szukaj"/>
                <img class ="form-group__icon" src="@/assets/symbols/search.svg">
                <ul class="list-group list-group--form" v-show="showList">
                  <li class="list-group-item list-group-item--form d-flex justify-content-between align-items-center" v-for="market in markets" :key="market.id">
                     {{market.sapNumber}} {{market.gallery_city}} {{market.number}} {{market.gallery}} {{market.category ? market.category.name : ''}}
                    <label class="checkbox checkbox--form multi-checkbox-wide"><input type="checkbox" :value="market.id" @click="pushSubMarkets()"><span class="checkmark"></span></label>
                  </li>
                </ul>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.status.$error }">
                <label>Status*</label>
                  <vueselect class="select--list" :options="statuses" :value="selectedStatus" label="name" v-model="selectedStatus" @input="setStat">
                    <template slot="no-options">
                      <p>Brak rekordów</p>
                    </template>
                  </vueselect>
                <labelInfo v-if="!$v.status.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.password1.$error || notSamePasswords || weekPassword }">
                  <label>Nowe hasło*</label>
                  <input class="form-control form-control-lg" autocomplete="new-password" type="password" v-model="password1"/>
                  <labelInfo v-if="!$v.password2.isTheSame" type="error" message="Wprowadzone hasła nie są jednakowe"/>
                  <labelInfo v-if="!$v.password1.minLength || !$v.password1.isStrange" type="error" message="Nowe hasło jest zbyt słabe. Hasło musi zawierać minimum 10 znaków, w tym: 1 wielką literę, 1 małą literę, 1 cyfrę i 1 znak specjalny."/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.password2.$error || notSamePasswords || weekPassword }">
                  <label>Powtórz hasło*</label>
                  <input class="form-control form-control-lg" autocomplete="new-password" type="password" v-model="password2"/>
                  <labelInfo v-if="!$v.password2.isTheSame" type="error" message="Wprowadzone hasła nie są jednakowe"/>
                  <labelInfo v-if="!$v.password2.minLength" type="error" message="Nowe hasło jest zbyt słabe. Hasło musi zawierać minimum 10 znaków, w tym: 1 wielką literę, 1 małą literę, 1 cyfrę i 1 znak specjalny."/>
              </div>
            </div>
          </div>
          <div class="form-footer">
            <p class="form-footer__paragraph">*pola wymagane</p>
            <div class="button-group button-group--editUser">
              <button class="button-normal button-normal--cancel" @click="$router.push('/users')">Wróć</button>
              <button class="button-normal button-normal--media" @click="onSubmit()">Zapisz</button>
            </div>
          </div>
          <div class="form-footer form-footer--deleteUser">
            <p class="form-footer__paragraph">Usuń użytkownika</p>
            <div class="button-group button-group--editUser">
              <button class="button-normal button-normal--media" @click="deleteWarning = true">Usuń</button>
            </div>
          </div>
        </div>
      </div>
      <warning v-if="deleteWarning" @cancel="deleteWarning = false" @confirm="deleteUser()"/>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import labelInfo from '@/components/blocks/labelInfo.vue'
import loader from '@/components/blocks/loader.vue'
import { setTimeout } from 'timers';
import { mixin as clickaway } from 'vue-clickaway';
import warning from '@/components/blocks/user/warning.vue'

export default {
  name: 'UserPassword',
  components:{

    labelInfo,
    loader,
    warning,

  },
  mixins: [validationMixin, clickaway],
  props: ['id', 'name', 'surname'],
  data () {
    return {
    
        title: `Edycja użytkownika`,

        password1:'',
        password2: '',

        invalid: false,
        changed: false,
        weekPassword: false,
        notSamePasswords: false,

        markets: [],
        subMarkets: [],

        categories: [],
        companiees: [],
        categoriesGun: [],
        categoriesMm: [],
        roles: [],
        rolesGun: [],
        rolesMm: [],
        statuses: [],

        fullName: '',
        email: '',
        company: '',
        role: '',
        category: '',
        parentMarket: '',
        status: 'active',

        selectedCompany: {id: '', name: ''},
        selectedCategory: {id: '', name: ''},
        selectedRole: {id: '', name: ''},
        selectedStatus: {id: '', name: ''},
        selectedParentMarket: {},

        showList: false,
        search: '',

        exist: false,
        deleteWarning: false,

    }
  },
  validations: {

    fullName: {

      required,
      minLength: minLength(4)

    },
    email: {

      required,
      email

    },
    company: {

      required,

    },
    roles: {

      required,

    },
    category: {

      required,

    },
    parentMarket: {

      isGut (){
        return this.isGut();
      },

    },
    status: {

      required,

    },
    password1: {

      minLength: minLength(8),
      isStrange(){ return this.isStrange() }

    },
    password2: {

      minLength: minLength(8),
      isTheSame(){ return this.isTheSame() }

    },
  },
  watch: {
    company: function(value){
      if ( value == 1 ) {
        this.categories = this.categoriesGun;
        this.roles      = this.rolesGun;
      } else {
        this.categories = this.categoriesMm;
        this.roles      = this.rolesMm;
      }
      
      setTimeout(() =>{
        this.role = this.roles[0];
        this.selectedRole = this.roles[0];
        this.category = this.categories[0].id;
        this.selectedCategory = this.categories[0];
      }, 50)
    },

    showList(){

      if(this.showList &&  this.subMarkets.length > 0){

        let checkboxes = document.querySelectorAll("input[type='checkbox']");

        for (let i = 0; i < checkboxes.length; i++) {

          let submarket = this.subMarkets.find(sub => sub.id == checkboxes[i].value);

          if(submarket){

            checkboxes[i].checked = true;

          }

        }

      }

    }
  },
  methods:{

    deleteUser(){

      const token = localStorage.getItem('auth_token');

      this.$http.delete(`users/${this.id}`, {
        headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        } }).then(response => {

          this.$router.push('/users');

        })

    },

    setCompany(selected) {
      this.company = selected.id;
    },

    setRole(selected) {
      this.role = selected.id;
    },

    setCategory(selected) {
      this.category = selected.id;
    },

    setStat(selected) {
      this.status = selected.id;
    },

    setParent(selected) {
      this.parentMarket = selected.id;
    },

    findRoleName(roleCode){

      let name = this.roles.find(role => role.id == roleCode);

      if(name) return name.name;

    },

    isStrange(){

      const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})");

      if ( this.password1 ) {

        // if(/[A-Z]/.test(this.password1) && /[!-\/:-@[-`{-~]/.test(this.password1)) {

        if(strongRegex.test(this.password1)) {

          return true;

        }else {

          return false;

        }
      }else{

        return false;

      }

    },

    isTheSame(){

      if ( this.password1 ) {
        if ( this.password1 === this.password2 ) {
            return true;
          } else {
            return false;
          }
      }else{
        return false;
      }

    },
      
      getFormData(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('users/form/data', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }})
        .then(response => {

          let companiees  = response.data.company;
          let categories  = response.data.category;
          let roles       = response.data.role;
          
          companiees.forEach((item)=>{
            this.companiees.push({id: item.id, name: item.name});
          });

          categories.forEach((item)=>{
            if ( item.id == 1 ) {
              this.categoriesGun.push({id: item.id, name: item.name});
            } else {
              this.categoriesMm.push({id: item.id, name: item.name});
            }
          });

          roles.forEach((item)=>{
            if ( item.id == 'ROLE_COORDINATOR' || item.id == 'ROLE_EDITOR' || item.id == 'ROLE_ADMIN' ) {
              this.rolesGun.push({id: item.id, name: item.name});
            } 

            if ( item.id == 'ROLE_LOCAL' || item.id == 'ROLE_CENTRAL' ) {
              this.rolesMm.push({id: item.id, name: item.name});
            }

          });

          this.statuses = [
            {id: 1, name: 'Aktywny'},
            {id: 2, name: 'Nieaktywny'}
          ]
              
        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    isGut(){
      
      if(this.company == 2){

        if(this.parentMarket != ''){
          return true;
        }

        return false;

      }

      return true;

    },

    getMarkets(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('market/markets', {
        params:{

          'limit': 100,

        },
        headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        } }).then(response => {

          this.markets = response.data.list;

        })

    },

    getUser(){

      const token = localStorage.getItem('auth_token');

      this.$http.get(`users/${this.id}`, {
        headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        }})
        .then(response => {

          const user = response.data;

          this.title = `Edycja użytkownika ${user.name} ${user.surname}`

          this.fullName             = `${user.name} ${user.surname}`;
          this.email                = user.email;
          this.company              = user.company.id;
          this.selectedCompany      = user.company;
          this.role                 = user.roles[0];
          if ( user.parent_market ) {
            this.parentMarket         = user.parent_market.id;
          }
          this.selectedParentMarket = user.parent_market;
          this.subMarkets           = user.sub_markets;

          setTimeout(()=>{
            const roleName          = this.findRoleName(user.roles[0]);
            this.role               = user.roles[0];
            this.selectedRole       = {id: user.roles[0], name: roleName};
            this.category           = user.category.id;
            this.selectedCategory   = user.category;
          }, 100);

          if(user.enabled){
            this.selectedStatus     = {id: 1, name: 'Aktywny'};
            this.status = 1;
          }else{
            this.selectedStatus     = {id: 2, name: 'Nieaktywny'};
            this.status = 2;
          }

        })

    },

    closeList(){

      this.showList = false;

    },

    pushSubMarkets(){

      let checkboxes = document.querySelectorAll("input[type='checkbox']");

      for (let i = 0; i < checkboxes.length; i++) {

        
        let market = this.markets.filter(market => market.id == checkboxes[i].value);
        let submarket = this.subMarkets.find(sub => sub.id == market[0].id);

        if(!submarket && checkboxes[i].checked){

          this.subMarkets.push(market[0]);

        }

        if(submarket && !checkboxes[i].checked){

          var index = this.subMarkets.map(x => {
            return x.Id;
          }).indexOf(checkboxes[i].value);

          this.subMarkets.splice(index, 1);

        }

      } 

    },

    onSubmit(){

      this.$v.fullName.$touch();
      this.$v.email.$touch();
      this.$v.company.$touch();
      this.$v.roles.$touch();
      this.$v.category.$touch();
      this.$v.parentMarket.$touch();
      this.$v.status.$touch();

      if(this.password1){

        this.$v.password1.$touch();
        this.$v.password2.$touch();

      }
      

      if (!this.$v.$error) {

        this.updateUser();

      }

    },

    updateUser(){

      let name = this.fullName.split(/ (.*)/);
      let sub = [];

        for(let i=0; i<this.subMarkets.length; i++){

          sub.push(this.subMarkets[i].id);

        }

        let newUser = {
          name: name[0],
          surname: name[1],
          username: this.email,
          email: this.email,
          company: this.company,
          category: this.category,
          parentMarket: this.parentMarket,
          roles: [this.role],
          subMarkets: sub,
          enabled: this.status == 1 ? true : false
        }

        if(this.password1 && this.password2){

          newUser['plainPassword'] = {
            first: this.password1,
  		      second: this.password2
          }

        }

        const token = localStorage.getItem('auth_token');

        this.$http.put(`users/${this.id}`, newUser, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }}).
          then(response => {

            this.$router.push('/users');
            this.exist = false;

          })
          .catch(error => {

              if(error.response.status === 400) {
              
                if(error.response.data.message.email){

                  this.exist = true;

                }

              }else{

                console.error(error.response);

              }

          });

    },

  },
  mounted(){

    this.getFormData();
    this.getMarkets();
    this.getUser();

  },

};
</script>

<style lang="scss">

.button-group--editUser{

  & button{
    height: 40px !important;
  }

  &:first-child{
    margin-right: 5px;
  }
}

.form-footer--deleteUser{
  margin-top:5%;
}

</style>
